export default __webpack_public_path__ + "1ed4e9339a2a818871baccb8ddd2f56c.jpg";